import { render } from "./admin-category.vue?vue&type=template&id=4ac8207e&scoped=true&ts=true"
import script from "./admin-category.vue?vue&type=script&lang=ts"
export * from "./admin-category.vue?vue&type=script&lang=ts"

import "./admin-category.vue?vue&type=style&index=0&id=4ac8207e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac8207e"]])

export default __exports__